module.exports = __webpack_public_path__ + "img/andrew-retain-visitors.7cba1baa.png";